export enum EThemeTemplate {
  HANTEC = 'HANTEC',
  DEFAULT = 'DEFAULT'
}

export const TENANT_THEMES_MAP: Record<string, EThemeTemplate> = {
  // hantec (in prod), demo2 (in sit), demo3 (in uat)
  hantec: EThemeTemplate.HANTEC,
  default: EThemeTemplate.DEFAULT
};
